import {observer} from 'mobx-react-lite';
import React from 'react';
import {EFlatButton, ESubmitButton} from 'webapp-lib/Components';

import {DialogContentActions, RightSide} from '#/Dialog/styles';

import {WizardStepProps} from '../CreateFromTemplateWizard.types';

type PreviewWrapperProps = {
  children: React.ReactElement | React.ReactElement[];
  nextButtonDisabled?: boolean;
  isSubmitting?: boolean;
} & WizardStepProps;

const UPreviewWrapper = ({
  children,
  backLabel,
  nextButtonDisabled,
  nextLabel,
  onNextClick,
  onBackClick,
  isSubmitting,
}: PreviewWrapperProps): React.ReactElement => (
  <>
    {children}
    <DialogContentActions stepperActions={true}>
      <EFlatButton testId='previewBack' onClick={onBackClick}>
        {backLabel}
      </EFlatButton>
      <RightSide>
        <ESubmitButton
          disabled={nextButtonDisabled}
          isSubmitting={isSubmitting ?? false}
          testId='previewNext'
          onClick={onNextClick}
        >
          {nextLabel}
        </ESubmitButton>
      </RightSide>
    </DialogContentActions>
  </>
);
export const PreviewWrapper = observer(UPreviewWrapper);
